import Store from '../../../store'
import API from './api'
import RecentNewsWrapper from './recent-news-wrapper.vue'

Store.registerModule('searchNews', {
  namespaced: true,
  state: {
    query: '',
    total: 0,
    current: 1,
    results: [],
    categories: [],
    numberOfResults: 0
  },
  mutations: {
    search(state, request) {
      API.search({
        SearchTerm: request.query || '',
        CurrentPage: 1,
        Categories: request.categories,
        PageSize: 8
      }).then(data => Object.assign(state, {
        query: request.query,
        total: data.NumberOfPages,
        current: 1,
        results: data.results,
        categories: request.categories,
        numberOfResults: data.NumberOfResults
      }))
    },
    paginate(state, current) {
      API.search({
        SearchTerm: state.query || '',
        CurrentPage: current,
        Categories: state.categories,
        PageSize: current === 1 ? 8 : 9
      }).then(data => Object.assign(state, {
        current,
        results: data.results,
        numberOfResults: data.NumberOfResults
      }))
    }
  }
})

export default RecentNewsWrapper
